/** Filtrování kategorií podle věku, pohlaví a příslušnosti k pořádajícímu oddílu */

export const calculateUserAge = (birthYear) => new Date().getFullYear() - birthYear

export const isUserInSameClub = (userClub, eventOrganizerClub) => userClub === eventOrganizerClub

export const filterCategoriesByAgeAndSex = (categories, userAge, userSex, isSameClub) => {
  const availableCategories = []

  if (userAge <= 13) {
    availableCategories.push('MDR')
  }

  if (userSex === 'F') {
    if (userAge <= 7) {
      availableCategories.push('W07', 'W09', 'W12', 'W14', 'W16', 'W19', 'W21')
    } else if (userAge <= 9) {
      availableCategories.push('W09', 'W12', 'W14', 'W16', 'W19', 'W21')
    } else if (userAge <= 12) {
      availableCategories.push('W12', 'W14', 'W16', 'W19', 'W21')
    } else if (userAge <= 14) {
      availableCategories.push('W14', 'W16', 'W19', 'W21')
    } else if (userAge <= 16) {
      availableCategories.push('W16', 'W19', 'W21')
    } else if (userAge <= 19) {
      availableCategories.push('W19', 'W21')
    } else if (userAge <= 34) {
      availableCategories.push('W21')
    } else if (userAge <= 44) {
      availableCategories.push('W35', 'W21')
    } else if (userAge <= 54) {
      availableCategories.push('W45', 'W35', 'W21')
    } else if (userAge <= 64) {
      availableCategories.push('W55', 'W45', 'W35', 'W21')
    } else if (userAge <= 99) {
      availableCategories.push('W65', 'W55', 'W45', 'W35', 'W21')
    }
  } else {
    if (userAge <= 7) {
      availableCategories.push('M07', 'M09', 'M12', 'M14', 'M16', 'M19', 'M21')
    } else if (userAge <= 9) {
      availableCategories.push('M9', 'M12', 'M14', 'M16', 'M19', 'M21')
    } else if (userAge <= 12) {
      availableCategories.push('M12', 'M14', 'M16', 'M19', 'M21')
    } else if (userAge <= 14) {
      availableCategories.push('M14', 'M16', 'M19', 'M21')
    } else if (userAge <= 16) {
      availableCategories.push('M16', 'M19', 'M21')
    } else if (userAge <= 19) {
      availableCategories.push('M19', 'M21')
    } else if (userAge <= 39) {
      availableCategories.push('M21')
    } else if (userAge <= 49) {
      availableCategories.push('M40', 'M21')
    } else if (userAge <= 59) {
      availableCategories.push('M50', 'M40', 'M21')
    } else if (userAge <= 69) {
      availableCategories.push('M60', 'M50', 'M40', 'M21')
    } else if (userAge <= 99) {
      availableCategories.push('M70', 'M60', 'M50', 'M40', 'M21')
    }
  }

  if (userAge <= 200) {
    availableCategories.push('OTHERS')
  }
  if (isSameClub) {
    availableCategories.push('ORG')
  }

  return availableCategories.flatMap((opt) => categories.filter((cat) => cat.option === opt))
}
